import request from '@/utils/request'

// 查询首页菜单列表
export function videourl(query) {
  return request({
    url: '/web/menu/videolist',
    method: 'get',
    params: query
  })
}

export function imagelisturl(query) {
  return request({
    url: '/web/image/list',
    method: 'get',
    params: query
  })
}